// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import HomePage from "./HomePage";
// import TutorPage from "./TutorPage";
// import StudentPage from "./StudentPage";
// import AdministratorPage from "./AdministratorPage";
// const RouterMain = () => {
//   return (
//     <div>
//       {/* <ScrollToTop/> */}
//       <Routes>
//        <Route path="/" element={<HomePage />} />
//         <Route path="/tutor" element={<TutorPage/>} />
//         <Route path="/student" element={<StudentPage/>} />
//         <Route path="/administrator" element={<AdministratorPage/>} />
//       </Routes>
//     </div>
//   );
// };

// export default RouterMain;

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TutorPage from "./TutorPage";
// import StudentPage from "./StudentPage";
import AdministratorPage from "./AdministratorPage";
import RootPage from "./RootPage";
import SideBarMenuTutor from "./SideBarMenuTutor";
import ModelPage from "./ModelPage";
import StudentCards from "./StudentCards";
import LessonPlanPage from "./LessonPlanPage";
import SideBarMenuStudent from "./SideBarMenuStudent";
import TutorCards from "./TutorCards";
import LoginForm from "./LoginForm";
import MainContent from "./MainContent";
import FileUpload from "./FileUpload";
import SimpleTabs from "./SimpleTabs";
const RouterMain = () => {
  

  return (
    <div>
      {/* <ScrollToTop/> */}
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/login" element={<LoginForm />} />
           <Route path="/simpletabs" element={<SimpleTabs />} />
         <Route path="/rootpage" element={<MainContent />} />
          <Route path="/maincontent" element={<MainContent />} />
         {/* <Route path="/" element={<LessonPlanPage />} /> */}
        <Route path="/tutor" element={<TutorCards />} />
        <Route path="/student" element={<StudentCards />} />
        <Route path="/administrator" element={<AdministratorPage />} />
        <Route path="/model" element={<FileUpload />  } />
                <Route path="/student-dashboard/:id" element={<SideBarMenuStudent />} />
        <Route path="/tutor-dashboard/:id" element={<SideBarMenuTutor />} />
      </Routes>
    </div>
  );
};

export default RouterMain;
